var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4780.646,
    height: 20,
    viewBox: "0 0 4780.646 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1779",
    "data-name": "\\u30D1\\u30B9 1779",
    d: "M0,0S170.738,20,341.476,20,512.214,0,682.951,0s170.737,20,341.474,20S1195.162,0,1365.9,0s170.738,20,341.476,20S1878.111,0,2048.848,0s170.737,20,341.475,20S2561.062,0,2731.8,0s170.737,20,341.474,20S3244.01,0,3414.747,0s170.739,20,341.476,20S3926.959,0,4097.7,0s170.738,20,341.476,20S4780.646,0,4780.646,0Z",
    transform: "translate(4780.646 20) rotate(180)",
    fill: "#eff5f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveGreen);
export default __webpack_public_path__ + "static/media/wave-green.74b2cb5a1d1636abd27102f081234967.svg";
export { ForwardRef as ReactComponent };